import { HttpClient } from "../HttpClient";

export const GetCurrentSubscription = async (params = {}) => {
  try {
    
    
    // Use the original endpoint with params
    const { data } = await HttpClient.get(
      "api/subscriptions/CurrentUserSubscriptions",
      {
        params: {
          ...(params.userId && { userId: params.userId }),
          ...(params.isImpersonation && { isImpersonation: params.isImpersonation }),
        }
      }
    );
    
    return await Promise.resolve(data);
  } catch (err) {
    console.error("❌ GetCurrentSubscription error:", err);
    return Promise.reject(err);
  }
};

// export const GetCurrentSubscription = async () => {
//   try {
//     const { data } = await HttpClient.get(
//       "api/subscriptions/CurrentUserSubscriptions"
//     );
//     return await Promise.resolve(data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
